import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { appStyles } from '../../../../styles';
import { UploadImage } from '../../../../assets';
import { ButtonActionPage } from '../../../atoms';
import { PartnerType } from '../../../../types/benefit';

export interface AttributeValues {
  backgroundImage?: string;
  textColor?: string;
  description?: string;
  title?: string;
  ctaText?: string;
  colorOpacity?: string;
  heading?: string;
  priceColor?: string;
  buttonBGColor?: string;
  buttonTextColor?: string;
}
interface PreviewProps {
  values: AttributeValues & any;
  isPreview?: boolean;
  height?: string;
  className?: string;
}

export const PreviewBenefit = (props: PreviewProps) => {
  const [partnerImage, setPartnerImage] = useState<string>();

  const { values, isPreview, height, className } = props;
  const { backgroundImage, title, partners, describeText, buttonList } = values;
  const isDefaultImage = backgroundImage === '' || !backgroundImage || !isPreview;

  useEffect(() => {
    if (values.partnerId && partners && partners.length) {
      const partner = partners.find((val: PartnerType) => val.id === values.partnerId);
      setPartnerImage(partner?.partnerBrandImageUrl);
    }
  }, [values]);

  const parseString = (str: string) => {
    const num: number = str.length;
    if (num > 60) {
      const newStr: string = str.substring(0, 60);
      return `${newStr}...`;
    }
    return str;
  };

  return (
    <StyledBenefitPreview className={className} style={{ height: height || '300px', backgroundColor: '#fff' }}>
      <div>
        <div className="preview-ant-image">
          <StyledLinearGradient />
          {!isDefaultImage ? (
            <img className="image-benefit" src={backgroundImage} alt="" />
          ) : (
            <div className="image-default">
              <img src={UploadImage} alt="" />
              <div>{describeText}</div>
            </div>
          )}
        </div>
        <div className="title-preview">
          {partnerImage ? (
            <div>
              <img className="img-partner" src={partnerImage} alt="" />
            </div>
          ) : null}
          <div className={title && !isDefaultImage ? 'blur-view' : ''}>
            {title && <div className="heading">{parseString(title)}</div>}
            {title && buttonList && (
              <ButtonActionPage id="1" text={buttonList || `Let's Go`} className="btn-learn-more" />
            )}
          </div>
        </div>
      </div>
    </StyledBenefitPreview>
  );
};

const StyledLinearGradient = styled.div`
  ${appStyles.fullWidthHeight}
  ${appStyles.borderRadiusPreview}
  position: absolute;
`;

const StyledBenefitPreview = styled.div`
  margin: 1.5rem;
  min-height: 293px;
  position: relative;
  text-align: left;
  line-height: 1.2;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 24px;
  & .heading {
    padding-top: 3px;
    text-align: center;
    color: white;
    font-weight: 800;
    font-size: 16px;
    margin-bottom: 12px;
    margin-top: 25px;
    width: 90%;
    transform: translateX(5%);
  }
  & .btn-learn-more {
    background: white;
    color: black;
    border: white;
    font-weight: 600;
    border-radius: 25px;
    margin: 0 0 0.8rem 0.5rem;
    width: auto;
    height: 2.3rem;
  }
  & .title-preview {
    text-align: center;
    position: absolute;
    top: 210px;
    left: 50%;
    transform: translateX(-50%);
  }
  & .preview-ant-image {
    position: relative;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0;
    height: 400px;

    & .image-benefit {
      border-radius: 24px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      padding: 0;
    }
    & .image-default {
      position: absolute;
      top: 30%;
      left: 55%;
      transform: translateX(-50%);
      & img {
        width: 6rem;
        height: 6rem;
      }
      & div {
        font-size: 15px;
        padding-top: 1rem;
      }
    }
  }

  .img-partner {
    width: auto;
    max-height: 4rem;
  }

  .blur-view {
    backdrop-filter: blur(2px);
    height: 101px;
    width: 305px;
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
  }

  .uploadText {
    position: absolute;
    width: 100%;
    text-align: center;
    margin-top: 4rem;
    color: white;
  }
  .textContainer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .wrapper-text-preview {
    position: absolute;
    bottom: 20%;
    width: 100%;
    padding: 0 1rem;
  }
  & .title {
    font-size: 25px;
  }
  & .priceColor {
    display: block;
    font-size: 11px;
  }
  .promotion-preview {
    & .description {
      font-size: 25px;
    }
    & .title {
      font-size: 14px;
    }
  }
  & .wrapper-btn-preview {
    position: absolute;
    bottom: 8px;
    width: 100%;
    display: flex;
    padding: 0 1rem;
    & .button {
      border-radius: 1rem;
      background: #fff;
      color: #000;
      height: 30px;
      font-size: 16px;
      padding: 0.2rem 1.25rem 0 1.25rem;
    }
  }

  @media screen and (max-width: 1440px) {
    .text-preview {
      bottom: 13%;
    }
    & .description {
      font-size: 12px;
    }
    & .title {
      font-size: 21px;
    }

    .promotion-preview {
      & .description {
        font-size: 21px;
      }
      & .title {
        font-size: 15px;
      }
    }
  }
`;
